import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';

import * as schemas from 'store/common/schemas';
import { selectAllEntities, selectUserEntities } from 'store/entities/selectors';

import * as helpers from './helpers';

export const selectUserSkills = createSelector(
  selectUserEntities,
  (state, props) => props.userId,
  selectAllEntities,
  (state, props) => props.category,
  (state, props) => props.isHighlighted,
  (userEntities, userId, entities, category, isHighlighted) =>
    userEntities[userId]
      ? denormalize(userEntities[userId].skills || [], [schemas.userSkill], entities)
          .map(us => {
            if (!us) return undefined;
            if (us.isDeleted) return undefined; // Do not show deleted skills

            // only show highlighted skills when isHighlighted bool is explicitly passed
            if (isHighlighted && !us.isHighlighted) return undefined;

            // only show skills with specific category e.g technology when category string is explicitly passed
            if (category && (us.skill.category || {}).id !== category.toLowerCase())
              return undefined;

            const result = {
              ...us,
              level: helpers.calculateLevel(us),
              validationCountsBySkillLevelIds: helpers.calculateValidationCountsBySkillLevelIds(us),
            };

            result.isValidatedAtCurrentLevel = !!(
              result.level &&
              result.level.id &&
              result.validationCountsBySkillLevelIds &&
              result.validationCountsBySkillLevelIds[result.level.id] &&
              result.validationCountsBySkillLevelIds[result.level.id] > 0
            );

            return result;
          })
          .filter(Boolean)
      : []
);

export const selectCountSkillsByCategory = createSelector(
  selectUserSkills,
  skills => skills.length
);
